/*
  Keeps the post-login return destination in sync with the live URL.

  routes.storefront_login_url is rendered server-side, so its return_to holds
  whatever the URL was at page load. variants.js rewrites the address bar with
  history.replaceState when a variant is picked, so without this the customer
  comes back to the product's default variant instead of the one they chose.
  Same applies to anything else that only lives in the query string.

  Rewrites return_to on sign-in links at click time.
*/
(function () {
  var LOGIN_PATH = '/customer_authentication/login';

  function refresh(link) {
    var url;

    try {
      url = new URL(link.getAttribute('href'), window.location.origin);
    } catch (e) {
      return;
    }

    // endsWith rather than a strict match: routes.* URLs carry the locale
    // prefix, so on a non-default locale the href is
    // /fr/customer_authentication/login.
    if (!url.pathname.endsWith(LOGIN_PATH)) return;

    // A return_to pointing somewhere other than the current page is a
    // deliberate destination -- leave it alone.
    var existing = url.searchParams.get('return_to') || '';
    var existingPath = existing.split('?')[0];
    if (existingPath && existingPath !== window.location.pathname) return;

    url.searchParams.set('return_to', window.location.pathname + window.location.search);
    link.setAttribute('href', url.pathname + url.search);
  }

  function handle(event) {
    if (!(event.target instanceof Element)) return;

    var link = event.target.closest('a[href*="' + LOGIN_PATH + '"]');
    if (link) refresh(link);
  }

  // mousedown covers middle-click and modifier-click opening a new tab, which
  // never fire a click event on the link.
  document.addEventListener('mousedown', handle, true);
  document.addEventListener('click', handle, true);
  document.addEventListener(
    'keydown',
    function (event) {
      if (event.key === 'Enter') handle(event);
    },
    true
  );
})();
